import { render, staticRenderFns } from "./infoImage.vue?vue&type=template&id=c061614a&scoped=true"
import script from "./infoImage.vue?vue&type=script&lang=js"
export * from "./infoImage.vue?vue&type=script&lang=js"
import style0 from "./infoImage.vue?vue&type=style&index=0&id=c061614a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c061614a",
  null
  
)

export default component.exports